// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .empresa:hover {\n  cursor: pointer;\n}\n.nombreEmpresa {\n  max-width: 250px;\n  white-space: nowrap;\n  overflow: hidden;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  text-overflow: ellipsis;\n}", ""]);
// Exports
module.exports = exports;
